import React, { useState, createContext, useContext, useEffect } from 'react';
import { FETCH_RX_PRODUCT_URL, INITIAL_RX_VALUES, RxProduct, RXValues } from '../site/types'; // Assuming you have your API URL here

// Define the context type
interface CartContextType {
    values: RXValues;
    setValues: React.Dispatch<React.SetStateAction<RXValues>>;
    handleSetValues: (newValues: RXValues) => void;
    loading: boolean;
    error: string | null;
    changesMade: boolean;
}

// Create the context with a default value
const CartContext = createContext<CartContextType>({
    values: INITIAL_RX_VALUES,
    setValues: () => { }, // No-op function as default
    handleSetValues: () => { }, // No-op function as default
    loading: false,
    error: null,
    changesMade: false,
});

// Create the provider component
interface CartProviderProps {
    children: React.ReactNode;
}

export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
    const [values, setValues] = useState<RXValues>(INITIAL_RX_VALUES);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [changesMade, setChangesMade] = useState<boolean>(false);

    const handleSetValues = (newValues: RXValues) => {
        setValues(prev => ({ ...prev, ...newValues }));
        setLoading(true);
        setError(null); // Reset error on refetch
        setChangesMade(true);
    };
    console.log(values)
    // Provide the context value to the children
    return (
        <CartContext.Provider value={{ values, setValues, error, loading, handleSetValues, changesMade }}>
            {children}
        </CartContext.Provider>
    );
};

// Create a custom hook to easily use the product context
export const useCart = () => {
    return useContext(CartContext);
};